import React from 'react'
import { SvgIconProps } from './Home'

const SvgLogoutIcon = ({ fill }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="18"
    fill="none"
    viewBox="0 0 16 18"
  >
    <path
      fill={fill ?? "#353535"}
      d="M15.934 7.33c-.087-.093-.087-.186-.175-.279l-1.313-1.484c-.175-.186-.35-.278-.525-.278-.175 0-.438.092-.526.278-.35.278-.35.835-.087 1.206H9.456c-.438 0-.788.371-.788.835 0 .464.35.835.788.835h3.852c-.263.371-.263.835 0 1.114.175.185.35.278.613.278.175 0 .437-.093.525-.278l1.313-1.3c.088-.092.175-.185.175-.278.088-.278.088-.464 0-.65z"
    ></path>
    <path
      fill={fill ?? "#353535"}
      d="M12.17 9.742c-.438 0-.788.371-.788.835v2.877c0 .092-.088.092-.088.092H8.317V4.732c0-.742-.437-1.392-1.05-1.67l-2.714-1.3h6.741c.088 0 .088 0 .088.094v2.876c0 .464.35.835.788.835.437 0 .788-.371.788-.835V1.856C12.958.836 12.17 0 11.207 0H1.75v.186V0C.876 0 .088.742 0 1.763V13.918c.175.742.613 1.299 1.313 1.67l4.553 2.226c.263.093.438.186.7.186.7 0 1.314-.464 1.576-1.113.088-.279.175-.464.175-.743v-.835h2.977c.963 0 1.751-.835 1.751-1.855v-2.877c0-.464-.35-.835-.875-.835zM1.663 13.361V2.227l4.99 2.412.088.093v11.412c0 .093-.087.093-.087.093h-.088L2.014 14.01c-.263-.092-.35-.37-.35-.65z"
    ></path>
  </svg>
)

export default SvgLogoutIcon